export default __webpack_public_path__ + "static/media/mars-onboarding-3.29df7cd7.svg";